import { useConfig } from '@/default-config';

export const useTranslations = () => {
    const { translations } = useConfig();

    return translations;
};
